import moment from "moment";
import {
  Row,
  Col,
} from "../../../CommonComponents";
import "./ApprovalHistory.scss";

const ApprovalHistory = (props: any) => {
  const { approvalHistory } = props
  return (
    <>
      <div className="approvalHistorycontainer">
        <div className="approvalHeader">Approval History</div>
        <Row>
          {approvalHistory?.map((list: any, index: number) => {
            return (
              <Col xs={12} sm={6} md={4} lg={3} xl={3} className="mb-3" key={list?.assignedTo}>
                <div className={`approvalCard ${list.status?.includes( "Approved") ? 'approvedContainer' : 'notApprovedContainer'}`}>
                  <div className="approvalCardHeader">
                    <div className="leftHeader">
                      <p><strong>Approver {index+1}</strong></p>
                      <p>{list.approvedBy}</p>
                    </div>
                    <div className="rightHeader">
                      <p><strong>{list.approvedDate ? moment(list.approvedDate).format('MMMM Do YYYY') : ''}</strong></p>
                      <p>{list.status}</p>
                    </div>
                  </div>
                  <div className="approvalCardBody">
                    {list?.approvalHistoryComments?.length ? list?.approvalHistoryComments?.map((comment: any, ind: any) => <p key={ind}>{comment?.comments}</p>)
                    :
                    <p className="no-comment-block">No Comments</p>
                    }
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </>
  );
};

export default ApprovalHistory;
